module.exports = __webpack_public_path__ + "static/assets/e63cba8e439578f337a8165515cbb43f.png";